<template>
  <a-row>
    <a-col :span="20">
      <div style="padding: 8px 0">
        <a-button type="primary" class="mr10" @click="showEdit(null)"
          >新增
        </a-button>
      </div>
    </a-col>
  </a-row>
  <a-table
    :rowKey="(record, index) => index"
    :scroll="{ x: 1000 }"
    :dataSource="dataList"
    :columns="columns"
    size="small"
    :pagination="false"
    class="mb20 "
  >
    <template #groupName="{record}">
      <a @click="showEdit(record)" style="color: #40a9ff">{{
        record.groupName
      }}</a>
    </template>

    <template #deal="{record}">
      <a-popconfirm title="确定删除?" @confirm="onDeleted(record.groupCode)">
        <a-button type="link">删除</a-button>
      </a-popconfirm>
    </template>
  </a-table>
  <Pagination
    v-if="dataList && dataList.length > 0"
    :page-num="pageNum"
    :page-size="pageSize"
    :total="total"
  />
</template>

<script>
import { inject, toRefs } from 'vue'

export default {
  name: 'MessageGroupTable',
  setup() {
    const groupState = inject('groupState')
    return {
      ...toRefs(groupState)
    }
  }
}
</script>

<style scoped></style>
